var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"guide"},_vm._l((_vm.guide),function(item,index){return _c('div',{key:index,staticClass:"guide-container"},[_c('div',{style:({color:_vm.color})},[_vm._v(_vm._s(item.label))]),(index+1<_vm.guide.length)?_c('div',{style:({color:_vm.color})},[_vm._v(" > ")]):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }